<template>
  <div id="data-search-list" class="w-full">
    <vs-popup :active.sync="showBlocked" title="Pessoa com conta restrita">
      <p style="color: red; font-weight: bold">
        Ops... Essa pessoa não pode ser incluída na gravação pois parece que o
        cadastro dela tem algum problema. Por favor, caso tenha dúvidas, entre
        em contato com a equipe do departamento de auditório.
      </p>
    </vs-popup>

    <div class="searching-contacts-container" v-if="!showContactsList">
      <vs-row vs-justify="center">
        <i class="fas fa-spinner fa-spin" style="font-size: 20px"></i>
      </vs-row>
      <p style="text-align: center">Buscando contatos<br />Aguarde...</p>
    </div>

    <div
      class="no-records"
      v-if="filteredParticipants.length < 1 && showContactsList"
    >
      <p>Nenhum participante encontrado</p>
    </div>

    <div
      id="recordings-participants-list"
      class="search-list force-child"
      v-if="showContactsList"
    >
      <vs-card
        class="cardlist-data-recordings"
        :key="indextr"
        style="
          padding: 5px 0 !important;
          margin: 0 !important;
          border-radius: 0;
          border-bottom: 1px solid #ddd;
        "
        v-for="(item, indextr) in filteredParticipants"
        :class="{ 'bg-light-success': selectedObj[item.id] }"
      >
        <div
          class="participant"
          style="padding: 10px !important; margin: 0 !important"
          @click="updateSelected(item.id, item.blacklist)"
          :class="{ active: idArray.includes(item.id) }"
        >
          <div class="participant-row">
            <div class="cardlist-logo" style="width: 40px">
              <!-- Avatar Col -->
              <div class="logo-container" style="width: 40px">
                <div class="img-container">
                  <img
                    v-if="item.photo"
                    :src="item.photo"
                    style="
                      width: 40px;
                      height: 40px;
                      object-fit: cover;
                      border-radius: 50%;
                      background-color: #ccc;
                    "
                  />
                  <span
                    v-else
                    class="rounded-letter"
                    style="width: 40px; height: 40px; padding: 8px 0"
                  >
                    {{ item.name | firstLetter }}
                  </span>
                  <div v-if="item.blacklist">
                    <i
                      class="fa fa-triangle-exclamation"
                      style="margin: 10px; color: red; font-size: 20px"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-description-container">
              <span class="contact-name-sp"
                >{{ item.name }} {{ item.surname }}</span
              >
              <div style="width: 100%">
                <vs-row style="width: 100%">
                  <div class="contact-halfColumn">
                    Idade: {{ item.birthdate | calculateAge }}
                  </div>
                  <div class="contact-halfColumn">
                    Gênero: {{ item.gender | formatGender }}
                  </div>
                </vs-row>
                <vs-row style="width: 100%">
                  <div class="contact-halfColumn">Email: {{ item.email }}</div>
                  <div class="contact-halfColumn">
                    Cel: {{ item.mobile | formatCelphone }}
                  </div>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { notifyError } from "../../../utils/notify";

export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    searching: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showBlocked: false,
      idArray: [],
      selectedObj: {},
      isSearching: false,
      showContactsList: false,
    };
  },
  watch: {
    searching(newValue) {
      console.log("NewValue isSearch", newValue);
      this.showContactsList = !newValue;
    },
    showContactsModal(newValue) {
      console.log("modalAlterado", newValue);
    },
  },
  computed: {
    filteredParticipants() {
      // lista para busca, com os participantes de uma gravacao removidos
      return this.$store.state.recording.searchList;
    },
  },
  methods: {
    clearSelected() {
      this.selectedObj = {};
      this.$emit("updateArr", []);
    },
    updateSelected(id, blacklist = null) {
      if (blacklist) {
        this.showBlocked = true;
        notifyError(this, "Conta com problema");
        return;
      }

      if (id) {
        if (this.selectedObj[id] || this.idArray.includes(id)) {
          this.idArray = this.idArray.filter((v) => v != id);
          delete this.selectedObj[id];
        } else {
          this.idArray.push(id);
          this.selectedObj[id] = true;
        }
        this.$emit("updateArr", this.idArray);
      }
    },
  },
  filters: {
    calculateAge(date) {
      if (!date) return "";
      var ageDifMs = Date.now() - new Date(date).getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    formatGender: (value) => {
      if (!value) return "";
      switch (value) {
        case "male":
          return "Masculino";
        case "female":
        case "feminine":
          return "Feminino";
        default:
          return "Outros";
      }
    },
    firstLetter: (value) => {
      if (!value) return "";
      return String(value[0] || " ").toUpperCase();
    },
    formatCelphone: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
  },
  created() {
    // reset component and its selected ids
    this.selectedObj = {};
    this.updateSelected();
  },
};
</script>

<style lang="scss" scoped>
.force-child :first-child {
  margin: 0 !important;
  padding: 0 !important;
}
.contact-halfColumn {
  width: 50%;
}
.contact-description-container {
  display: flex;
  flex-direction: column;
  padding: 0 6px;
  width: 100%;
}
.contact-name-sp {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
.searching-contacts-container {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.participant-row {
  display: flex;
  flex-direction: row;
}

div.participant {
  cursor: pointer;
}
.active-fields-btn {
  margin: -2px 0 0 10px;
  float: left;
}
</style>
